import { connect } from 'react-redux';
import { AppState } from '../../../../../types/store';
import {
  getProfileOwnerStats,
  isCurrentUserProfileOwner,
} from '../../../../selectors/users';

export default connect((state: AppState) => ({
  isOwner: isCurrentUserProfileOwner(state),
  stats: getProfileOwnerStats(state),
}));
